module.exports = __webpack_public_path__ + "static/media/slide-img-2.caf1d812.png";